module.exports = __webpack_public_path__ + "static/media/081-no smartphones.1961e9c0.svg";